/**
 * wim-photoswipe-loader.js
 * Carga on-demand de PhotoSwipe (Fase 3b del ADR de rendimiento).
 *
 * PhotoSwipe (30 KB) se sacó de libs.min.js a `wim-photoswipe.js` y ya NO se carga
 * en el arranque. Solo se usa en la galería de PDP al abrir el zoom, y theme.min.js
 * (no editable) hace `new PhotoSwipe(...)` de forma SÍNCRONA en el handler del click.
 *
 * Estrategia: interceptar el trigger en fase de CAPTURA (corre antes que el handler
 * delegado de theme.min.js), bloquear ese primer click, cargar wim-photoswipe.js y
 * re-emitir el click para que theme.min.js lo maneje ya con window.PhotoSwipe presente.
 * Además se pre-carga en `pointerdown` (antes del click) para ocultar la latencia.
 * Una vez cargado, el interceptor deja pasar (comprueba window.PhotoSwipe).
 *
 * Requiere `window.wimPhotoSwipeSrc` con la URL del asset (inyectada en el layout).
 */
(() => {
  'use strict';

  const SELECTOR = '[data-action="open-product-zoom"], .Product__SlideItem--image';
  let loading = null;

  const load = () => {
    if (window.PhotoSwipe) return Promise.resolve();
    if (loading) return loading;
    const src = window.wimPhotoSwipeSrc;
    if (!src) return Promise.reject(new Error('wimPhotoSwipeSrc no definido'));
    loading = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src;
      s.onload = () => resolve();
      s.onerror = () => {
        loading = null;
        reject(new Error('fallo al cargar wim-photoswipe.js'));
      };
      document.head.appendChild(s);
    });
    return loading;
  };

  const matches = (e) => {
    const t = e.target;
    return t && t.closest ? t.closest(SELECTOR) : null;
  };

  // Pre-carga por intención: al presionar (antes del click) empieza la descarga.
  document.addEventListener(
    'pointerdown',
    (e) => {
      if (window.PhotoSwipe) return;
      if (matches(e)) load().catch(() => {});
    },
    { capture: true, passive: true }
  );

  // Interceptor de correctitud: bloquea el primer click, carga, re-emite.
  document.addEventListener(
    'click',
    (e) => {
      if (window.PhotoSwipe) return; // ya cargado → deja pasar al handler del theme
      const trigger = matches(e);
      if (!trigger) return;
      if (!window.wimPhotoSwipeSrc) return; // sin URL no podemos cargar: no bloquear
      e.preventDefault();
      e.stopPropagation();
      load()
        .then(() => {
          trigger.click(); // re-emitir: ahora theme.min.js hace new PhotoSwipe con éxito
        })
        .catch(() => {});
    },
    true // fase de captura: antes que el handler delegado (burbuja) de theme.min.js
  );
})();
